export type ModifierType  = '%_ADJUSTMENT' | '$_ADJUSTMENT';

export interface VoucherItem {
    catalogueItemId: number;
    active: boolean;
    expired: boolean;
}

export interface VoucherQualifier {
    qualifierId: number;
    level: string;
    value: number;
    modifierType: ModifierType;
    voucherItems: VoucherItem[];
    active: boolean;
    expired: boolean;
}

export interface VoucherItemAdjustment {
    catalogueItemId: number;
    active: boolean;
    expired: boolean;
    value: number;
    modifierType: ModifierType;
}
